import { useStack } from '@/react/common/stacks/queries/useStack';
import { useEnvironmentId } from '@/react/hooks/useEnvironmentId';

import { useGitHelmDryRun } from '../helmReleaseQueries/useGitHelmDryRun';
import { GitHelmDryRunPayload } from '../helmReleaseQueries/gitHelmTypes';
import { HelmRelease } from '../types';

export function useManifestFromStackID(
  stackID?: number,
  release?: HelmRelease
) {
  const environmentId = useEnvironmentId();
  const stackQuery = useStack(stackID);
  const credentialID =
    stackQuery.data?.GitConfig?.Authentication?.GitCredentialID;

  const payload: GitHelmDryRunPayload = {
    name: release?.name || '',
    namespace: release?.namespace || '',
    repositoryURL: stackQuery.data?.GitConfig?.URL || '',
    helmChartPath: stackQuery.data?.HelmChartPath || '',
    helmValuesFiles: stackQuery.data?.HelmValuesFiles || [],
    repositoryReferenceName: stackQuery.data?.GitConfig?.ReferenceName,
    repositoryAuthentication:
      !!stackQuery.data?.GitConfig?.Authentication?.Username || !!credentialID,
    repositoryUsername: stackQuery.data?.GitConfig?.Authentication?.Username,
    repositoryPassword: stackQuery.data?.GitConfig?.Authentication?.Password,
    repositoryAuthorizationType:
      stackQuery.data?.GitConfig?.Authentication?.AuthorizationType,
    repositoryGitCredentialID: credentialID,
    tlsSkipVerify: stackQuery.data?.GitConfig?.TLSSkipVerify,
  };

  const manifestQuery = useGitHelmDryRun(environmentId, payload);

  return manifestQuery;
}
